/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Website_OpenInputs */

const cs_blog_website_open = /** @type {(inputs: Blog_Website_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít na webu`)
};

const en_blog_website_open = /** @type {(inputs: Blog_Website_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open on website`)
};

/**
* | output |
* | --- |
* | "Open on website" |
*
* @param {Blog_Website_OpenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_website_open = /** @type {((inputs?: Blog_Website_OpenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Website_OpenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_website_open(inputs)
	return cs_blog_website_open(inputs)
});